export default __webpack_public_path__ + "static/media/6A3_E-1642.be6edb50.png";